import {style} from 'typestyle'
import * as csstips from 'csstips'

export const HomeRankingModule = style({
    boxShadow: '0 5px 8px 0 rgba(51,51,51,0.05)',
    borderRadius: 8,
    maxWidth: 450,
    position: 'relative',
    width: '92vw',
    margin: '0 auto',
    marginBottom: 15,
    background: '#fff'
})

export const title = style({
    fontSize: 20,
    color: '#000000',
    letterSpacing: 0,
    lineHeight: '20px',
    fontWeight: 500,
    paddingRight: 15,
    paddingLeft: 15,
    paddingTop: 15,
    paddingBottom: 14
})

export const HomeRankingContentLeft = style({})

export const HomeRankingContentWrapNormal = style({
    background: '#fff',
    // width: '40.53vw',
    // maxWidth: 194.56,
    borderRadius: 10,
    width: 'calc(50% - 5px)',
    // boxShadow: '0 2px 5px 0 rgba(0,0,0,0.10)',
    marginBottom: 15
    // $nest: {
    //     '&:active': {
    //         backgroundColor: '#f8f8f8'
    //     }
    // }
})

export const HomeRankingContentTop = style({})

export const HomeRankingContentWrap = style({
    position: 'relative',
    // marginLeft: 15,
    // marginRight: 15,
    background: '#FFFFFF',
    // boxShadow: '0 2px 5px 0 rgba(0,0,0,0.10)',
    margin: '0px 15px 15px 15px',
    paddingTop: 15,
    paddingBottom: 15,
    ...csstips.flexRoot,
    $nest: {
        '&:after': {
            content: `""`,
            position: 'absolute',
            width: '100%',
            height: 1,
            background: '#f0f0f0',
            bottom: 0,
            transform: 'scaleY(0.5)'
        }
        // '&:active': {
        //     backgroundColor: '#f8f8f8'
        // }
    }
})

export const Imagewrap = style({
    overflow: 'hidden',
    borderRadius: 6
})

export const HomeRankingCover = style({
    position: 'relative',
    width: '43.46vw',
    height: '24.8vw',
    maxWidth: 208,
    maxHeight: 119,
    backgroundSize: 'cover',
    borderRadius: 6,
    overflow: 'hidden'
})

export const HomeRankingCoverNormal = style({
    position: 'relative',
    height: '22.13vw',
    maxHeight: 106,
    backgroundSize: 'cover',
    borderRadius: 6,
    overflow: 'hidden'
})

export const HomeRankingContentRight = style({
    ...csstips.flexRoot,
    flexDirection: 'column',
    ...csstips.betweenJustified,
    marginLeft: 10,
    width: '37.86vw',
    maxWidth: 202
})

export const HomeRankingContentBottom = style({
    ...csstips.flexRoot,
    flexDirection: 'column',
    ...csstips.betweenJustified,
    marginTop: 10
})

export const HomeRankingContentRightTitle = style({
    fontSize: 16,
    color: '#333333',
    lineHeight: '22px',
    marginBottom: 13,
    height: 44,
    fontWeight: 500
})

export const HomeRankingContentButton = style({
    ...csstips.betweenJustified,
    ...csstips.flexRoot
})

export const popularNum = style({
    ...csstips.flexRoot,
    ...csstips.center,
    $nest: {
        img: {
            position: 'relative',
            top: -1,
            width: 10,
            display: 'inline-block'
        },
        p: {
            fontSize: 12,
            color: '#999999',
            letterSpacing: 0,
            lineHeight: '12px',
            display: 'inline-block',
            marginLeft: 5
        }
    }
})

export const listenBtn = style({
    cursor: 'pointer',
    background: '#FF5A31',
    boxShadow: '0 3px 5px 0 rgba(255,90,49,0.40)',
    borderRadius: 50,
    // width: '20vw',
    // height: '8.5vw',
    ...csstips.flexRoot,
    ...csstips.center,
    ...csstips.content,
    // maxWidth: 75,
    // maxHeight: 32,
    $nest: {
        'img': {
            width: 12,
            marginRight: 5,
            $nest: {
                '@media (max-width: 330px)': {
                    width: 8
                }
            }
        },
        'i': {
            fontStyle: 'normal',
            fontSize: 14,
            fontWeight: 500,
            color: '#fff',
            $nest: {
                '@media (max-width: 330px)': {
                    fontSize: 10
                }
            }
        },
        '&:active': {
            background: '#f05d39'
        }
    }
})

export const noramlRankList = style({
    ...csstips.flexRoot,
    ...csstips.betweenJustified,
    ...csstips.wrap,
    position: 'relative',
    margin: '0 auto',
    marginTop: 5,
    marginBottom: 10,
    // marginLeft: 15,
    // marginRight: 15,
    width: 'calc(100% - 30px)'
})

export const RankCoverTag = style({
    position: 'absolute',
    width: '17.33vw',
    maxWidth: 83.2,
    bottom: 0,
    right: 0
})

export const RankCoverTagNormal = style({
    position: 'absolute',
    width: '14.13vw',
    maxWidth: 67.84,
    bottom: 0,
    right: 0
})

export const playBtn = style({
    padding: '8px 15px 8px 15px',
    cursor: 'pointer',
    ...csstips.flexRoot,
    ...csstips.center,
    $nest: {
        '@media (max-width: 330px)': {
           padding: '7px 11px 7px 11px'
        }
    }
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeRankingModule/HomeRankingModule.style.ts